import { FC, PropsWithChildren } from 'react';
import styles from './styles.module.scss';
export const GraphsListHeader: FC<PropsWithChildren> = ({ children }) => {
  return <header className={styles.graphsListHeader}>{children}</header>;
};
